export class EdgeCalculatorCoefficients {
    constructor() {
        this.sphericalPreferredDistance = 2;
        this.sphericalMotion = 1;
        this.sphericalSequencePenalty = 1;
        this.sphericalMergeCCPenalty = 4;
        this.sphericalProjectPenalty = 1;
        this.stepPreferredDistance = 8;
        this.stepPreferredDistanceLeftRight = 8;
        this.stepMotion = 3;
        this.stepRotation = 0.5;
        this.stepSequencePenalty = 2;
        this.stepMergeCCPenalty = 6;
        this.stepProjectPenalty = 1;
        this.similarDistance = 2;
        this.similarRotation = 3;
        this.turnDistance = 4;
        this.turnMotion = 2;
        this.turnSequencePenalty = 1;
        this.turnMergeCCPenalty = 4;
        this.turnProjectPenalty = 1;
    }
}
//# sourceMappingURL=EdgeCalculatorCoefficients.js.map